var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CustomerService"},[(_vm.isShowZhangLogin)?_c('a',{attrs:{"href":(_vm.href + "&clientId=" + _vm.name)}},[_c('img',{attrs:{"src":require("./../assets/img/kf.png"),"alt":""}})]):_c('a',{attrs:{"href":_vm.tklUrl}},[_c('img',{attrs:{"src":require("./../assets/img/kf.png"),"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6a1cc00","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomerService.vue
// module id = null
// module chunks = 